<template lang="pug">
AppMapMarker.activities-location-start-marker(
  :marker="marker"
  has-icon
  :z-index="zIndex"
  :icon-url="startIconUrl"
  :icon-size="size"
)
</template>

<script>
import { activitiesMarker } from '~/mixins';
import { ICON_MARKER_START } from '~/rails_assets';

export default {
  name: 'ActivitiesLocationStartMarker',
  mixins: [activitiesMarker({ zIndex: 2 })],
  computed: {
    startIconUrl: () => ICON_MARKER_START,
  },
};
</script>
